import type { CSSProperties, ReactNode } from 'react';

/**
 * A public-domain Roman landscape painting as a surface. Images and full
 * provenance live in public/art (PROVENANCE.json); every painting carries its
 * credit, because the licence asks for nothing but honesty does.
 */
export const PAINTINGS = {
  aqueduct: {
    artist: 'Hubert Robert',
    title: 'Aqueduct in Ruins',
    url: 'https://www.metmuseum.org/art/collection/search/437471',
  },
  cascade: {
    artist: 'Hubert Robert',
    title: 'Bridge over a Cascade',
    url: 'https://www.metmuseum.org/art/collection/search/437474',
  },
  portico: {
    artist: 'Hubert Robert',
    title: 'The Portico of a Country Mansion',
    url: 'https://www.metmuseum.org/art/collection/search/437468',
  },
  campagna: {
    artist: 'Claude Lorrain',
    title: 'Pastoral Landscape: The Roman Campagna',
    url: 'https://www.metmuseum.org/art/collection/search/435906',
  },
  sunrise: {
    artist: 'Claude Lorrain',
    title: 'Sunrise',
    url: 'https://www.metmuseum.org/art/collection/search/435907',
  },
  crescenza: {
    artist: 'Claude Lorrain',
    title: 'View of La Crescenza',
    url: 'https://www.metmuseum.org/art/collection/search/435909',
  },
  'ancient-rome': {
    artist: 'Giovanni Paolo Panini',
    title: 'Ancient Rome',
    url: 'https://www.metmuseum.org/art/collection/search/437244',
  },
} as const;

export type PaintingName = keyof typeof PAINTINGS;

export function Painting({
  name,
  className,
  style,
  children,
}: {
  name: PaintingName;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}) {
  const p = PAINTINGS[name];
  return (
    <div
      className={className ? `s-painting ${className}` : 's-painting'}
      style={{ backgroundImage: `url(/art/${name}.webp)`, ...style }}
    >
      {children}
      <span className="s-credit">
        {p.artist},{' '}
        <a href={p.url} target="_blank" rel="noopener noreferrer">
          {p.title}
        </a>{' '}
        · The Met, CC0
      </span>
    </div>
  );
}
